import React, { useState } from "react";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { DownOutlined } from "@ant-design/icons";
import { Collapse, Divider } from "antd";
const { Panel } = Collapse;

const DealCard = ({
  data,
  isHomePage,
  openModal,
  onClick,
  isSubService,
  onButtonClick,
  edit,
  isAppointmentEdit,
  isAppointment,
}) => {
  const [showVariants, setShowVariants] = useState(false);

  const getServiceData = useSelector((state) => {
    return state.service.value.serviceCategory;
  });
  const categoryName = getServiceData?.find(
    (item) => item._id === data?.serviceCategoryId || data?.serviceCategory?._id
  );
  const categoryNameDeal = getServiceData?.find(
    (item) => item?._id === data?.category
  );

  const toggleVariants = () => {
    setShowVariants((prevShowVariants) => !prevShowVariants);
  };
  const VariantCard = ({ data, index }) => {
    return (
      <>
        <div className="grid grid-cols-2 md:grid-cols-6 w-full md:p-0 p-1 gap-2">
          <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
            <p className="font-bold text-primaryPurple">Variant#</p>
            <p className="text-black font-medium">{index}</p>
          </div>
          <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
            <p className="font-bold text-primaryPurple">Variant</p>
            <p className="text-black font-medium">{data?.variantTitle}</p>
          </div>
          <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
            <p className="font-bold text-primaryPurple">App Allowed</p>
            <p className="text-black font-medium">
              {data?.isAppointment ? "Yes" : "No"}
            </p>
          </div>
          <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
            <p className="font-bold text-primaryPurple">Tesla Service</p>
            <p className="text-black font-medium">
              {data?.isTeslaService ? "Yes" : "No"}
            </p>
          </div>
          <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
            <p className="font-bold text-primaryPurple">Discount</p>
            <p className="text-black font-medium">${data?.discountAmount}</p>
          </div>
          <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
            <p className="font-bold text-primaryPurple">Price</p>
            <p className="text-black font-medium">${data?.servicePrice}</p>
          </div>
          <div></div>
        </div>
        <Divider className="sm:hidden" />
      </>
    );
  };
  return (
    <div
      onClick={onClick}
      className={
        isHomePage || isAppointment || isSubService
          ? "grid grid-cols-2 w-full items-center content-start justify-items-center p-0 sm:p-2 sm:place-items-center border-boxGrey border rounded-sm shadow-md bg-white justify-center md:grid md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-9"
          : "grid grid-cols-2 w-full items-center content-center justify-items-center py-2 border-boxGrey border-solid rounded-sm shadow-md bg-white justify-center md:grid md:grid-cols-6 lg:grid lg:grid-cols-6"
      }
    >
      <div className="bg-blue border border-gray-200  rounded lg:mx-3 xl:mx-3 xl:h-full">
        <p className="font-bold text-primaryPurple">Category</p>
        <p className="text-black font-medium">
          {isHomePage || isAppointment
            ? data?.serviceCategory?.name ?? categoryName?.name
            : isSubService
            ? data?.subServiceCategoryId?.name
            : categoryNameDeal?.name}
        </p>
      </div>
      <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
        <p className="font-bold text-primaryPurple">
          {isSubService ? "Sub Service" : "Service"}
        </p>
        <p className="text-black font-medium">{data?.serviceName}</p>
      </div>
      <div className="border-white rounded-full shadow-md hidden sm:flex items-center justify-center">
        {isHomePage || isAppointment || isAppointmentEdit ? (
          <img
            className="rounded-full w-6 h-6 "
            // alt="yupup-logo"
            src={
              data?.serviceImage === "" || !data?.serviceImage
                ? data?.serviceCategory?.image ?? categoryNameDeal?.image
                : data?.serviceImage
            }
          />
        ) : isSubService ? (
          <img
            className="rounded-full w-6 h-6 "
            src={
              data?.serviceImage === "" || !data?.serviceImage
                ? data?.subServiceCategoryId?.image
                : data?.serviceImage
            }
          />
        ) : (
          <img
            className="rounded-full w-6 h-6 "
            // alt="yupup-logo"
            src={data?.image}
          />
        )}
      </div>
      {isHomePage || isAppointment ? (
        <div className="bg-blue border border-gray-200 lg:rounded lg:mx-3 xl:rounded xl:mx-3 xl:h-full">
          <p className="font-bold text-primaryPurple">Appointment Type</p>
          <p className="text-black font-medium">
            {data?.promoDealType?.replace(/_/g, " ")}
          </p>
        </div>
      ) : (
        ""
      )}
      {isHomePage || isAppointment || isSubService ? (
        <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
          <p className="font-bold text-primaryPurple">Tesla Service</p>
          <p className="text-black font-medium">
            {data?.isTeslaService ? "Yes" : "No"}
          </p>
        </div>
      ) : (
        ""
      )}
      {isSubService ? (
        <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
          <p className="font-bold text-primaryPurple">Parent Service </p>
          <p className="text-black font-medium">{`${data?.parent?.[0]?.serviceName}`}</p>
        </div>
      ) : (
        ""
      )}
      <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
        <p className="font-bold text-primaryPurple">Discount Amount</p>
        <p className="text-black font-medium">{`$${
          Number.isInteger(data?.discountAmount)
            ? data?.discountAmount
            : data?.discountAmount?.toFixed(2) || data?.discount
        }`}</p>
      </div>
      <div className="bg-blue border border-gray-200 rounded lg:mx-3 xl:mx-3 xl:h-full">
        <p className="font-bold text-primaryPurple">Original Price</p>
        {isHomePage || isAppointment || isSubService ? (
          <p className="text-black">
            {`$${parseFloat(data?.servicePrice)?.toLocaleString()}`}
          </p>
        ) : (
          <p className="text-black font-medium">{`$${data?.price}`}</p>
        )}
      </div>
      {isHomePage || isSubService ? (
        <div className="bg-blue border border-gray-200 rounded lg:mt-2 lg:mx-3 xl:mt-2 xl:mx-3 xl:h-full">
          <div
            onClick={() => {
              edit(data);
            }}
            className="hover:cursor-pointer"
          >
            <EditIcon />
          </div>
        </div>
      ) : (
        ""
      )}
      {isAppointment ? (
        <div className="bg-blue border border-gray-200 rounded lg:mt-2 lg:mx-3 xl:mt-2 xl:mx-3 xl:h-full">
          <div
            onClick={() => isAppointmentEdit(data)}
            className="hover:cursor-pointer"
          >
            <EditIcon />
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="bg-blue border border-gray-200 rounded lg:mt-2 lg:mx-3 xl:mt-2 xl:mx-3 xl:h-full">
        <div className="mr-6 sm:pt-0 pt-2">
          <DeleteIcon className="hover:cursor-pointer" onClick={openModal} />
          <DownOutlined
            className="font-bold text-[20px] ml-2 mt-1"
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering the onClick event of the parent div
              toggleVariants();
            }}
          />
        </div>
      </div>
      {showVariants && (
        <div className="w-full col-span-2 md:col-span-6">
          {data?.variants?.length > 0
            ? data?.variants?.map((variant, index) => (
                <div key={index} className="variant-card">
                  <VariantCard data={variant} index={index + 2} />
                </div>
              ))
            : ""}
        </div>
      )}
    </div>
  );
};

export default DealCard;
